import React, { useState } from "react";
import SettingsLayout from "../../../layouts/SettingsLayout";
import SettingsHeading from "../../../settings/SettingsHeading";
import Recruiter from "../../../../apiResources/Recruiter";
import RecruiterUser from "../../../../apiResources/RecruiterUser";
import Employer from "../../../../apiResources/Employer";
import EmployerUser from "../../../../apiResources/EmployerUser";
import Loader from "../../../library/Loader";
import Divider from "../../../library/Divider";
import CompanyUrlSettingsOption from "../../../settings/CompanyUrlSettingsOption";
import SocialUsernameSettingsOption from "../../../settings/SocialUsernameSettingsOption";

const Socials = (props: Props) => {
  const [editFocus, setEditFocus] = useState<string>(null);
  const { user, company } = props;

  const isDisabled = (value) => Boolean(editFocus) && editFocus !== value;
  const isEditing = (value) => Boolean(editFocus) && editFocus === value;

  if (!user || !company) {
    return (
      <SettingsLayout>
        <Loader />
      </SettingsLayout>
    );
  }

  return (
    <SettingsLayout user={user} company={company}>
      <SettingsHeading>Social</SettingsHeading>
      <SocialUsernameSettingsOption
        user={user}
        company={company}
        name="twitterUsername"
        label="Twitter Username"
        placeholder="hiringhub"
        disabled={isDisabled("twitter")}
        onEditStart={() => setEditFocus("twitter")}
        isEditing={isEditing("twitter")}
        onEditComplete={() => setEditFocus(null)}
      />
      <Divider />
      <SocialUsernameSettingsOption
        user={user}
        company={company}
        name="instagramUsername"
        label="Instagram Username"
        placeholder="hiring_hub"
        disabled={isDisabled("instagram")}
        onEditStart={() => setEditFocus("instagram")}
        isEditing={isEditing("instagram")}
        onEditComplete={() => setEditFocus(null)}
      />
      <Divider />
      <CompanyUrlSettingsOption
        user={user}
        company={company}
        name="facebookUrl"
        label="Facebook Url"
        placeholder="https://www.facebook.com/HiringHub"
        disabled={isDisabled("facebook")}
        onEditStart={() => setEditFocus("facebook")}
        isEditing={isEditing("facebook")}
        onEditComplete={() => setEditFocus(null)}
      />
      <Divider />
      <CompanyUrlSettingsOption
        user={user}
        company={company}
        name="linkedinUrl"
        label="LinkedIn Url"
        placeholder="https://www.linkedin.com/company/hiring-hub-com"
        disabled={isDisabled("linkedIn")}
        onEditStart={() => setEditFocus("linkedIn")}
        isEditing={isEditing("linkedIn")}
        onEditComplete={() => setEditFocus(null)}
      />
      <Divider />
      <CompanyUrlSettingsOption
        user={user}
        company={company}
        name="glassdoorUrl"
        label="Glassdoor Url"
        placeholder="https://www.glassdoor.co.uk/Jobs/The-Hiring-Hub-Jobs-E3355205.htm"
        disabled={isDisabled("glassdoor")}
        onEditStart={() => setEditFocus("glassdoor")}
        isEditing={isEditing("glassdoor")}
        onEditComplete={() => setEditFocus(null)}
      />
    </SettingsLayout>
  );
};

type Props = {
  user: RecruiterUser | EmployerUser;
  company: Recruiter | Employer;
};

export default Socials;
